import { errors } from '~/tools/errors';
import { accountActions } from '../actions/account.actions';

// Redirect user to login page if action was rejected with `errors.types.tokenExpired`.
const tokenExpiredMiddleware = (store) => (next) => async (action) => {
  if (action?.error && action?.type !== 'account/getActivationDetails/rejected') {
    const isTokenExpiredError =
      action.error.message?.includes(errors.types.tokenExpired) ||
      action.error.name?.includes(errors.types.tokenExpired);

    if (isTokenExpiredError) {
      // TODO: Can this be handled at a higher level so we need only pass the action.error?
      const tokenExpiredError = errors.createError({
        // @ts-expect-error TS(2322): Type 'string' is not assignable to type 'null | un... Remove this comment to see the full error message
        name: errors.types.tokenExpired,
        message: `${errors.types.tokenExpired}: please login again`,
      });

      // @ts-expect-error TS(2554): Expected 0 arguments, but got 1.
      return store.dispatch(accountActions.logout(tokenExpiredError));
    }
  }

  return next(action);
};

export default tokenExpiredMiddleware;
